import { fill } from "./copy";
import type { MeterView } from "./planMeterView";

/** A quiet meter where allowance matters: "1 of 3 designs on your plan", with a bar (KEY-560). */
export function PlanMeter({ view, template }: { view: MeterView; template: string }) {
  const text = fill(template, { used: view.used, allowed: view.allowed });
  return (
    <div className="kd-plan-meter" role="meter" aria-valuemin={0} aria-valuemax={view.allowed} aria-valuenow={view.used} aria-label={text}>
      <span>{text}</span>
      <span className="kd-plan-meter-track" aria-hidden="true">
        <span className="kd-plan-meter-fill" style={{ width: `${Math.round(view.fraction * 100)}%` }} />
      </span>
    </div>
  );
}
